import { render, staticRenderFns } from "./AddDosageFormTem.vue?vue&type=template&id=1698e5fa&scoped=true"
import script from "./AddDosageFormTem.vue?vue&type=script&lang=js"
export * from "./AddDosageFormTem.vue?vue&type=script&lang=js"
import style0 from "./AddDosageFormTem.vue?vue&type=style&index=0&id=1698e5fa&prod&lang=scss&scoped=true"
import style1 from "./AddDosageFormTem.vue?vue&type=style&index=1&id=1698e5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1698e5fa",
  null
  
)

export default component.exports